const extractYouTubeId = (src) => {
  if (!src) return null;
  try {
    const url = new URL(src);
    const host = url.hostname.toLowerCase();
    // youtube.com/watch?v=ID or /embed/ID
    if (host.includes('youtube.com')) {
      const v = url.searchParams.get('v');
      if (v) return v;
      const parts = url.pathname.split('/').filter(Boolean);
      // handle /embed/ID or other path endings
      if (parts.length) return parts[parts.length - 1];
    }
    // youtu.be/ID
    if (host === 'youtu.be') {
      const parts = url.pathname.split('/').filter(Boolean);
      if (parts.length) return parts[0];
    }
  } catch (e) {
    // src might be just an ID string
  }
  const trimmed = String(src).trim();
  if (/^[\w-]{8,}$/.test(trimmed)) return trimmed;
  return null;
};

const Video = ({ src }) => {
  const videoId = extractYouTubeId(src);
  const iframeSrc = videoId
    ? `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`
    : src;

  return (
    <iframe
      src={iframeSrc}
      title="YouTube video player"
      role="region"
      aria-label="YouTube video player"
      tabIndex={0}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      className="rounded-2xl w-full h-64 sm:h-[20em] md:h-[25em]"
    />
  );
};

export default Video;
